import * as Types from '../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Wed Nov 19 2025 14:02:42 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type GetLiveJoinDataQueryVariables = Types.Exact<{
  hashedId: Types.Scalars['HashedId']['input'];
}>;


export type GetLiveJoinDataQuery = { __typename?: 'Query', liveStreamEvent: { __typename?: 'LiveStreamEvent', id: string, title: string, hashedId: string, scheduledFor: string, lifecycleStatus: Types.LiveStreamLifecycleStatus, settings: { __typename?: 'Settings', rtmpIngestEnabled: boolean, preRecorded: boolean } } };


export const GetLiveJoinDataDocument = gql`
    query GetLiveJoinData($hashedId: HashedId!) {
  liveStreamEvent(hashedId: $hashedId) {
    id
    title
    hashedId
    scheduledFor
    lifecycleStatus
    settings {
      rtmpIngestEnabled
      preRecorded
    }
  }
}
    `;

/**
 * __useGetLiveJoinDataQuery__
 *
 * To run a query within a React component, call `useGetLiveJoinDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveJoinDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveJoinDataQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useGetLiveJoinDataQuery(baseOptions: Apollo.QueryHookOptions<GetLiveJoinDataQuery, GetLiveJoinDataQueryVariables> & ({ variables: GetLiveJoinDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveJoinDataQuery, GetLiveJoinDataQueryVariables>(GetLiveJoinDataDocument, options);
      }
export function useGetLiveJoinDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveJoinDataQuery, GetLiveJoinDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveJoinDataQuery, GetLiveJoinDataQueryVariables>(GetLiveJoinDataDocument, options);
        }
export function useGetLiveJoinDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLiveJoinDataQuery, GetLiveJoinDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiveJoinDataQuery, GetLiveJoinDataQueryVariables>(GetLiveJoinDataDocument, options);
        }
export type GetLiveJoinDataQueryHookResult = ReturnType<typeof useGetLiveJoinDataQuery>;
export type GetLiveJoinDataLazyQueryHookResult = ReturnType<typeof useGetLiveJoinDataLazyQuery>;
export type GetLiveJoinDataSuspenseQueryHookResult = ReturnType<typeof useGetLiveJoinDataSuspenseQuery>;
export type GetLiveJoinDataQueryResult = Apollo.QueryResult<GetLiveJoinDataQuery, GetLiveJoinDataQueryVariables>;